import React, { Component } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import passengerTypesEnum from '../../constants/passenger-types-enum';

import BookerSelect from './booker-select';
import CopyNumberOfTravelers from '../global/copy-number-of-travelers';
import * as BookerActions from '../../../redux/actions/booking/booker-action-creators';

import TranslatedCopy from '../../intl/translated-copy';

const mapStateToProps = state => ({
  passengersData: state.Booker.passengersData,
});

class BookerPassengerSelector extends Component {
  constructor(props) {
    super(props);

    this.state = {
      MAX_BOOKING_PASSENGERS: 7,
      passengerSelectorInFocus: null,
      popupPosition: 'right',
    };
  }

  render() {
    const { popupPosition, handleFocusFullQuickbookerPassenger } = this.props;

    return (
      <BookerSelect
        buttonText={ this.renderButtonText() }
        currentID='btnPaxSelect'
        handleFocusFullQuickbookerPassenger= { handleFocusFullQuickbookerPassenger }
        idPopUpPaxSelector='idPopUpPaxSelector'
        modifierClass='passengerSelector'
        popupContent={ this.renderPopupContent() }
        popupPosition={ popupPosition }/>
    );
  }

  renderButtonText() {
    const { passengersData } = this.props;

    return (
      <span>
        <span>
          <CopyNumberOfTravelers passengersData={ passengersData } />
        </span>
        <span className='Icon Icon--arrowSmallDown' />
      </span>
    );
  }

  renderPopupContent() {
    const {
      passengersData,
      passengersMap,
    } = this.props;

    const { passengerSelectorInFocus, MAX_BOOKING_PASSENGERS } = this.state;
    const maxTotalPassengers = MAX_BOOKING_PASSENGERS;
    let totalPassengers = 0;

    for (const i in passengersData) {
      totalPassengers += passengersData[i];
    }

    const isAddPassengerDisabled = totalPassengers >= maxTotalPassengers;
    let isRemoveAdultDisabled = (totalPassengers === 2 && passengersData[passengerTypesEnum.INFANT] === 1)
    || ( passengersData[passengerTypesEnum.CHILD] >= 1  && passengersData[passengerTypesEnum.ADULT] === 1 );

    return passengersMap.map((passenger, i) => {
      const passengerSelectorClasses = cx({
        'BookerPassengerSelector': true,
        'is-inFocus': passengerSelectorInFocus === i,
      });

      const count = passengersData[passenger.type];

      const countClasses = cx({
        'BookerPassengerSelector-count': true,
        'is-disabled': count === 0,
      });

      const min = passenger.min;
      const max = passenger.type === passengerTypesEnum.INFANT ? passengersData.ADULT : maxTotalPassengers;
      isRemoveAdultDisabled = isRemoveAdultDisabled && passenger.type === passengerTypesEnum.ADULT;

      return (
        <div
          className={ passengerSelectorClasses }
          key={ i }
          onMouseEnter={ () => this.handlePassengerSelectorFocus(null) }>
          <div className='BookerPassengerSelector-buttons'>
            <button
              aria-label='-'
              className='BookerPassengerSelector-button BookerPassengerSelector-button--down'
              disabled={ count === passenger.min || totalPassengers === 1 || isRemoveAdultDisabled }
              onBlur={ () => this.handlePassengerSelectorFocus(null) }
              onClick={ () => this.handleChangeCount(passenger.type, count - 1, min) }
              onFocus={ () => this.handlePassengerSelectorFocus(i) } />
            <div className={ countClasses }>{ count }</div>
            <button
              aria-label='+'
              className='BookerPassengerSelector-button BookerPassengerSelector-button--up'
              disabled={ count === max || isAddPassengerDisabled }
              onBlur={ () => this.handlePassengerSelectorFocus(null) }
              onClick={ () => this.handleChangeCount(passenger.type, count + 1, min) }
              onFocus={ () => this.handlePassengerSelectorFocus(i) } />
          </div>
          <div className='BookerPassengerSelector-details'>
            <h4 className='BookerPassengerSelector-name'>
              <TranslatedCopy copyID={ passenger.copyID } paxCount={ count } />
            </h4>
            <p className='BookerPassengerSelector-desc u-textLowercase'>
              { this.getPassengerAgeRestrictions(passenger) }
              <TranslatedCopy copyID='APP_YEARS' />
            </p>
          </div>
        </div>
      );
    });
  }

  handleChangeCount(type, count, min) {
    const { dispatch, maxTotalPassengers } = this.props;

    const passengersData = { ...this.props.passengersData };
    const max = type === passengerTypesEnum.INFANT ? passengersData.ADULT : maxTotalPassengers;

    if (count < min || count > max) {
      return;
    }

    passengersData[type] = count;

    if (passengersData.INFANT > passengersData.ADULT) {
      passengersData.INFANT = passengersData.ADULT;
    }

    dispatch(BookerActions.changePassengerCount(passengersData));
  }

  /**
   * @param  {Number} i - index of PassengerSelector that houses the focused button
   */
  handlePassengerSelectorFocus(i) {
    this.setState({
      passengerSelectorInFocus: i,
    });
  }

  getPassengerAgeRestrictions(passenger) {
    if (passenger.ageMin === 0) {
      return `< ${passenger.ageMax} `;
    } else if (passenger.ageMax === null) {
      return `> ${passenger.ageMin} `;
    } else {
      return `${passenger.ageMin} - ${passenger.ageMax} `;
    }
  }
}

export default connect(mapStateToProps)(BookerPassengerSelector);
